import { format } from 'd3-format';

export const formatNumber = (
  value: number,
  abbreviate: boolean = false
): string => {
  if (Math.abs(value) >= 1e7 && abbreviate) {
    // hundreds of millions
    return formatNumberWithMagnitude(value);
  }
  return format(',.0f')(value);
};

export const formatNumberWithMagnitude = (value: number): string => {
  return format('.3s')(value).replace('G', 'B');
};

export const formatNumberWithDecimals = (
  value: number,
  decimals: number = 2
): string => {
  // Use a format that shows up to specified decimal places but removes trailing zeros
  const formatString = `,.${decimals}f`;
  return format(formatString)(value).replace(/\.?0+$/, '');
};

export const formatPercentage = (
  value: number,
  minDecimals: number = 0,
  maxDecimals: number = 2,
  showSign: boolean = true
): string => {
  const formatted = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: minDecimals,
    maximumFractionDigits: maxDecimals,
  }).format(value);

  const sign = showSign && value > 0 ? '+' : '';
  return sign + formatted + '%';
};
